import asyncFetch from '../utils/asyncFetch';
import { toaster } from 'evergreen-ui';

const loginRequest = async ({ username, password }) => {
  try {
    const result = await asyncFetch(`${process.env.REACT_APP_BACKEND_URL}/auth/local`, {
      method: 'POST',
      body: { identifier: username, password, domain: 'grabkings' },
    });
    return result;
  } catch (error) {
    if (error.data && error.data.statusCode === 400) {
      toaster.danger('Incorrect username or password');
    } else {
      toaster.danger('Something went wrong');
    }
  }
};

export default loginRequest;
